import React from 'react';

export default function MusicalNoteSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Cream background tint (subtle) */}
      <rect x="0" y="0" width="40" height="40" fill="#FFF8E1" opacity="0.15" />
      {/* Eighth note - large, top-left */}
      <ellipse cx="9" cy="14" rx="3.5" ry="2.5" fill="#212121" transform="rotate(-20 9 14)" />
      <rect x="11.5" y="4" width="1.5" height="11" fill="#212121" />
      <path d="M13 4 C16 5 17 8 16 11 C16 9 14 7 13 7 Z" fill="#212121" />
      {/* Eighth note - medium, center-right */}
      <ellipse cx="26" cy="22" rx="3" ry="2.2" fill="#212121" transform="rotate(-15 26 22)" />
      <rect x="28" y="13" width="1.3" height="10" fill="#212121" />
      <path d="M29.3 13 C31.5 14 32 16 31 18 C31 16.5 30 15.5 29.3 15.5 Z" fill="#212121" />
      {/* Beamed pair of notes, bottom */}
      <ellipse cx="14" cy="32" rx="2.5" ry="1.8" fill="#212121" transform="rotate(-15 14 32)" />
      <ellipse cx="22" cy="33" rx="2.5" ry="1.8" fill="#212121" transform="rotate(-15 22 33)" />
      <rect x="16" y="25" width="1.2" height="8" fill="#212121" />
      <rect x="24" y="26" width="1.2" height="8" fill="#212121" />
      {/* Beam */}
      <path d="M16 25 L25 26 L25 27.6 L16 26.6 Z" fill="#212121" />
      {/* Small note dot, top-right */}
      <ellipse cx="33" cy="9" rx="1.8" ry="1.3" fill="#424242" transform="rotate(-15 33 9)" />
      <rect x="34.2" y="3" width="0.9" height="6.5" fill="#424242" />
      {/* Highlights on noteheads */}
      <ellipse cx="8" cy="13.5" rx="0.7" ry="0.4" fill="white" opacity="0.4" transform="rotate(-20 8 13.5)" />
      <ellipse cx="25.5" cy="21.5" rx="0.6" ry="0.3" fill="white" opacity="0.35" />
    </svg>
  );
}
